export const fraudRulesSummaryCard = [
    {
      title: "ALL FRAUD RULES",
      objKeyRepr: "fraudRules",
    },
    {
        title: "ACTIVE RULES",
        objKeyRepr: "activeRules",
      },
      {
        title: "INACTIVE RULES",
        objKeyRepr: "inactiveRules",
      },
      {
        title: "RULES TRIGGERED (24H)",
        objKeyRepr: "rulesTriggeredToday",
      },
];
  
export const fraudEventsSummaryCard = [
    {
        title: "ALL FRAUD EVENTS",
        objKeyRepr: "fraudEvents",
    },
    {
        title: "FLAGGED EVENTS",
        objKeyRepr: "flaggedEvents",
      },
      {
        title: "UNDER REVIEW",
        objKeyRepr: "underReview",
      },
      {
        title: "CONFIRMED FRAUD",
        objKeyRepr: "confirmedFraud",
      },
];
  
export const fraudRulesDataKeysAndRepr = [
    { objKey: "ruleId", repr: "RULE ID" },
    { objKey: "ruleName", repr: "RULE NAME" },
    { objKey: "ruleType", repr: "RULE TYPE" }, // e.g transaction, velocity, geo
    { objKey: "riskLevel", repr: "RISK LEVEL" }, // Low, Medium, High
    { objKey: "status", repr: "STATUS" }, // Active/Inactive
    { objKey: "triggerCount", repr: "TRIGGER COUNT" },
    { objKey: "lastTriggered", repr: "LAST TRIGGERED" },
    { objKey: "dateCreated", repr: "DATE CREATED" },
    { objKey: "category", repr: "CATEGORY" }, // transaction monitoring, kyc violation, sanctions screening
    { objKey: "action", repr: "ACTION" },
  ];
  
export const fraudEventsDataKeysAndRepr = [
    { objKey: "merchantId", repr: "MERCHANT ID" },
    { objKey: "merchantName", repr: "NAME" },
    { objKey: "customerIp", repr: "IP ADDRESS" },
    { objKey: "merchantEmail", repr: "EMAIL ADDRESS" },
    { objKey: "scenario", repr: "SCENARIO" },
    { objKey: "actionPerformed", repr: "ACTION PERFORMED" },
    { objKey: "date", repr: "DATE" },
  ];